module.exports = __webpack_public_path__ + "videos/kviz-science-SK.8746944.mp4";